'use strict';

import RegxConstant from '../constants/RegxConstant';
import { GetAppData } from '../core/core';

const _typeof =
  typeof Symbol === 'function' && typeof Symbol.iterator === 'symbol'
    ? function (obj) {
        return typeof obj;
      }
    : function (obj) {
        return obj && typeof Symbol === 'function' && obj.constructor === Symbol && obj !== Symbol.prototype
          ? 'symbol'
          : typeof obj;
      };

// Filename: formurlencoded.js
// Timestamp: 2017.07.04-19:19:11 (last modified)
// Author(s): Bumblehead (www.bumblehead.com), JBlashill (james@blashill.com), Jumper423 (jump.e.r@yandex.ru)

const FormEncode = function (data) {
  const opts = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  const sorted = Boolean(opts.sorted);
  const skipIndex = Boolean(opts.skipIndex);
  const ignorenull = Boolean(opts.ignorenull);
  const encode = function encode(value) {
    return String(value)
      .replace(
        /(?:[\0-\x1F"-&\+-\}\x7F-\uD7FF\uE000-\uFFFF]|[\uD800-\uDBFF][\uDC00-\uDFFF]|[\uD800-\uDBFF](?![\uDC00-\uDFFF])|(?:[^\uD800-\uDBFF]|^)[\uDC00-\uDFFF])/g,
        encodeURIComponent,
      )
      .replace(/ /g, '+')
      .replace(/[!'()~\*]/g, function (ch) {
        return `%${ch.charCodeAt().toString(16).slice(-2).toUpperCase()}`;
      });
  };
  const keys = function keys(obj) {
    const keyarr = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : Object.keys(obj);
    return sorted ? keyarr.sort() : keyarr;
  };
  const filterjoin = function filterjoin(arr) {
    return arr
      .filter(function (e) {
        return e;
      })
      .join('&');
  };
  const objnest = function objnest(name, obj) {
    return filterjoin(
      keys(obj).map(function (key) {
        return nest(`${name}[${key}]`, obj[key]);
      }),
    );
  };
  const arrnest = function arrnest(name, arr) {
    return arr.length
      ? filterjoin(
          arr.map(function (elem, index) {
            return skipIndex ? nest(`${name}[]`, elem) : nest(`${name}[${index}]`, elem);
          }),
        )
      : encode(`${name}[]`);
  };
  var nest = function nest(name, value) {
    const type =
      arguments.length > 2 && arguments[2] !== undefined
        ? arguments[2]
        : typeof value === 'undefined'
        ? 'undefined'
        : _typeof(value);
    let f = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : null;

    if (value === f) {
      f = ignorenull ? f : `${encode(name)}=${f}`;
    } else if (/string|number|boolean/.test(type)) {
      f = `${encode(name)}=${encode(value)}`;
    } else if (Array.isArray(value)) {
      f = arrnest(name, value);
    } else if (type === 'object') {
      f = objnest(name, value);
    }

    return f;
  };

  return (
    data &&
    filterjoin(
      keys(data).map(function (key) {
        return nest(key, data[key]);
      }),
    )
  );
};
/**
 * 未添加注释
 */

// type 为 checkout 时  data 传入merchant_items
// type 为 orderdetail 时  data 传入orderDetail
const isThisIsMiGood = (type, data) => {
  if (!type || typeof type !== 'string') {
    return false;
  }

  type = type.toLowerCase();
  if (type !== 'checkout' && type !== 'orderdetail') {
    return false;
  }

  let isMiGood = false;
  if (type === 'checkout') {
    if (!Array.isArray(data)) {
      return false;
    }
    // checkout接口  merchant_items 中 0-有品配送, 1-独立库存, 2-小米网, 3-跨有品和独立库存活动, 4-失效商品
    data.map((item) => {
      if (item.type === 2) {
        isMiGood = true;
      } else {
        isMiGood = false;
      }
    });

    return isMiGood;
  }

  if (type === 'orderdetail') {
    if (!data || typeof data !== 'number') {
      return false;
    }
    // vendorType  1 小米网 shopapi，2：独立库存，3：三方
    if (data == 1) {
      isMiGood = true;
    } else {
      isMiGood = false;
    }

    return isMiGood;
  }
};

const computeIsLockRecLoad = (pageIndex = 0, pageSize = 0, totalCount = 0) => {
  if (pageIndex !== 1) {
    return true;
  }

  if (totalCount < pageSize) {
    return false;
  }

  return true;
};

const parseExtImages = (ext) => {
  if (ext && ext.img) {
    return ext.img.split(',');
  }
  return [];
};

const parseImageSize = (ext) => {
  if (ext && ext.img) {
    if (ext.img.includes('w=1080')) {
      return true;
    } else {
      return false;
    }
  }
};

const getObjProps = (obj, propStr) => {
  if (!obj) {
    return false;
  }
  propStr = propStr.trim();
  const len = propStr.length;
  const pointIndex = propStr.indexOf('.');
  if (pointIndex === -1) {
    if (obj.hasOwnProperty(propStr)) {
      return obj[propStr];
    } else {
      return false;
    }
  }
  if (pointIndex === 0 || pointIndex === len) {
    return false;
  }
  const key = propStr.substr(0, pointIndex);
  const props = propStr.substr(pointIndex + 1, len);
  if (key in obj) {
    return getObjProps(obj[key], props);
  } else {
    return false;
  }
};

/**
 * 获取数组值
 * @param {*} obj
 * @param {*} key  [**] ***[***]
 */
const getArrValue = (obj, propStr) => {
  const regex = '\\[(.+?)\\]';
  const matchResult = propStr.match(regex); // 匹配[]中的内容
  if (matchResult) {
    const propArr = propStr.split('[');
    const curObj = propArr[0] == '' ? obj : obj[propArr[0]] || [];
    return {
      isMatchArr: true,
      obj: curObj && matchResult[1] && curObj[matchResult[1]],
    };
  } else {
    return {
      isMatchArr: false,
      obj: obj,
    };
  }
};

const getObjPropsV2 = (obj, propStr) => {
  if (!obj) {
    return false;
  }
  propStr = propStr.trim();
  const len = propStr.length;
  const pointIndex = propStr.indexOf('.');
  if (pointIndex === -1) {
    const matchResult = getArrValue(obj, propStr);
    if (matchResult.isMatchArr) {
      return matchResult.obj;
    } else if (obj.hasOwnProperty(propStr)) {
      return obj[propStr];
    } else {
      return false;
    }
  }
  if (pointIndex === 0 || pointIndex === len) {
    return false;
  }
  const key = propStr.substr(0, pointIndex);
  const props = propStr.substr(pointIndex + 1, len);
  const curMatchResult = getArrValue(obj, key);
  if (typeof obj === 'object' && key in obj) {
    return getObjPropsV2(obj[key], props);
  } else if (curMatchResult.isMatchArr) {
    return getObjPropsV2(curMatchResult.obj, props);
  } else {
    return false;
  }
};

const parseExtColor = (ext) => {
  if (ext && ext.color) {
    return ext.color;
  } else {
    return '';
  }
};

/**
 * 判断是否为Array
 * @param arr {Object}
 * @return {Boolean}
 */
const isArray = (arr) => {
  return Array.isArray(arr);
};

/**
 * 判断是否为function
 * @param obj {Object}
 * @return {Boolean}
 */
const isFunction = (obj) => {
  return Object.prototype.toString.call(obj) === '[object Function]';
};

/**
 * 判断是否为object
 * @param obj {Object}
 * @return {Boolean}
 */
const isObject = (obj) => {
  return Object.prototype.toString.call(obj) === '[object Object]';
};

// 判断是否为空对象
const isEmptyObj = (obj) => {
  if (!isObject(obj)) {
    return true;
  }
  for (const key in obj) {
    return false;
  }
  return true;
};

const unique = (array, key) => {
  if (Array.isArray(array)) {
    const obj = {};
    const uniqueArr = array.filter((item) => {
      const keyValue = item[key];
      if (!obj[keyValue]) {
        obj[keyValue] = true;
        return true;
      }
      return false;
    });
    return uniqueArr;
  }
  return array;
};

/**
 * 如果传空，则金额默认为0
 * @param amount
 * @returns {string}
 */
const amountFormat = (amount = 0) => {
  if (!Number.isInteger(amount)) {
    const fixed = Number(amount).toFixed(2);
    if (fixed.endsWith('00')) {
      return parseInt(fixed, 10);
    }
    return fixed;
  }
  return amount;
};
/**
 * 价格格式化
 * @param {Number} origin
 * @return  {String}
 */
const getFormatPrice = (origin, notDivide) => {
  let price = String(origin);
  const dot = price.lastIndexOf('.');
  if (dot > 0) {
    price = Number(origin).toFixed(2);
  } else if (!notDivide) {
    price = (Number(origin) / 100).toFixed(2);
  } else {
    price = Number(origin).toFixed(2);
  }
  if (price.endsWith('00')) {
    price = price.substring(0, price.length - 3);
  } else if (price.endsWith('0')) {
    price = price.substring(0, price.length - 1);
  }

  return price;
};

/**
 * 返回秒级时间戳
 * @returns {number}
 */
const currentTimeStamp = () => {
  return new Date().getTime() / 1000;
};

/**
 * url的参数解析为字符串对象
 * @param {String} url
 * @return {Object}
 */
const parseQueryString = (url) => {
  let arr;
  const res = {};
  // #符号之后的值称为hash，都不会加到request请求中去
  url = url.split('#')[0];
  // 获取queryString 第一个？号后面的全是查询字符串
  arr = url.split('?');
  arr.shift();
  const queryStr = arr.join('?');
  // 查询字符串为空直接返回 避免出现这样的返回值{"":""}
  if (queryStr.trim().length === 0) {
    return res;
  }

  // 获取参数
  arr = queryStr.split('&');
  for (let i = 0; i < arr.length; i++) {
    const itemArr = arr[i].split('=');
    // 第一个=号之前的是name 后面的全是值
    const name = itemArr.shift();
    const value = itemArr.join('=');
    res[name] = decodeURIComponent(value);
  }
  return res;
};
/**
 * 解析 url 里各部分
 * @param {String} url
 * @return {Object}
 */
const urlParse = (url) => {
  let arr;
  const res = {};
  // #符号之后的值称为hash，都不会加到request请求中去
  const hashUrl = url.split('#');
  url = hashUrl[0];
  const hash = hashUrl[1];
  // 获取queryString 第一个？号后面的全是查询字符串
  arr = url.split('?');
  const urlPath = arr.shift();
  const queryStr = arr.join('?');
  // 查询字符串为空直接返回 避免出现这样的返回值{"":""}
  if (queryStr.trim().length === 0) {
    return res;
  }

  // 获取参数
  arr = queryStr.split('&');
  for (let i = 0; i < arr.length; i++) {
    const itemArr = arr[i].split('=');
    // 第一个=号之前的是name 后面的全是值
    const name = itemArr.shift();
    const value = itemArr.join('=');
    res[name] = value;
  }
  return {
    url: urlPath,
    query: res,
    hash: hash || '',
  };
};
/**
 * 更改 url 里的参数值
 * @param {String} url
 * @param {Object} obj
 */
const updateQueryString = (url, obj) => {
  if (!obj) {
    return url;
  }
  const result = urlParse(url);
  const urlPath = result.url;
  const query = result.query;
  const hash = result.hash;
  if (result) {
    for (const key in obj) {
      query[key] = obj[key];
    }
    const queryArr = [];
    for (const key in query) {
      queryArr.push(`${key}=${query[key]}`);
    }
    return urlPath + (queryArr ? `?${queryArr.join('&')}` : '') + (hash || '');
  } else {
    return url;
  }
};
/*
 * 得到图片的尺寸
 * @param {String} url
 */
const getImgSize = (url) => {
  const urlArr = url.split('&');
  const result = {};
  for (let i = 1; i < urlArr.length; i++) {
    const _d = urlArr[i];
    const _dArr = _d.split('=');
    if (_dArr[0] === 'w' && _dArr[1]) {
      result.w = _dArr[1];
    }
    if (_dArr[0] === 'h' && _dArr[1]) {
      result.h = _dArr[1];
    }
  }
  return result;
};
/**
 * 图片的url 增加 webp参数
 * @param {String} url
 * @return {String}
 */
const webpFormat = (pic_url) => {
  if (!pic_url || typeof window === 'undefined') {
    return pic_url;
  }

  if (!window.WebpSupport) {
    return pic_url.split('t=webp').join('');
  }
  if (!pic_url.includes('t=webp')) {
    if (pic_url.includes('?')) {
      pic_url += '&t=webp';
    } else {
      pic_url += '?t=webp';
    }
  }
  return pic_url;
};

const webpFormatZip = (url, w = 100, h = 100) => {
  if (!url) {
    return '';
  }
  const app = GetAppData();

  // http to https
  if (url.indexOf('http://') > -1) {
    url = url.replace('http://', 'https://');
  }
  // 是否已经支持webp
  if (url.indexOf('=webp') > -1) {
    return url;
  }

  // gif图片不支持webp
  if (url.indexOf('.gif') > -1) {
    return url;
  }

  // m站如果不支持webp 就把webp的参数去掉
  if (app.isInM()) {
    if (!window.WebpSupport) {
      url = url.split('t=webp').join('');
      url = url.split('F=webp').join('');
      return url;
    }
  }
  // 通过域名判断是否为 kscloud
  if (url.indexOf('img.youpin.mi-img.com') > -1) {
    url = url.split('?')[0];
    if (url.indexOf('@base@tag=imgScale') === -1) {
      url = url + '@base@tag=imgScale';
    }
    url = url + '&F=webp';
  }

  if (url) {
    url = url + '&w=' + w + '&h=' + h;
    return url;
  } else {
    return '';
  }
};

/**
 * 将阿拉伯数字转化为中文汉字数字
 * 0 - 10^18
 * @param num {Number}
 * @return {String}
 * @throws {Error}
 */
const convertToChineseNumber = (num) => {
  if (typeof num !== 'number' || parseInt(num, 10) !== parseInt(num, 10)) {
    throw new Error('Num must be a number.');
  }
  const strNum = num.toString();
  if (strNum.length > 23) {
    throw new Error('The number is too large.');
  }
  const numberMap = {
    1: '一',
    2: '二',
    3: '三',
    4: '四',
    5: '五',
    6: '六',
    7: '七',
    8: '八',
    9: '九',
    0: '零',
  };
  const units = ['', '万', '亿', '兆', '吉', '太', '拍', '艾'];
  const convertArray = [];

  /**
   * 将小于10000的数字编译成中文数字
   * @param str {string}
   * @returns {string}
   */
  const compileNumber = (str) => {
    let ifZero = false;
    let start = true;
    const unit = ['', '十', '百', '千'];
    let result = '';
    for (let i = 0; i < str.length; ++i) {
      if (str[i] !== numberMap[0]) {
        if (ifZero) {
          ifZero = false;
          if (start) {
            start = false;
            result += str[i] + unit[str.length - 1 - i];
          } else {
            result += numberMap[0] + str[i] + unit[str.length - 1 - i];
          }
        } else {
          if (start) {
            start = false;
          }
          result += str[i] + unit[str.length - 1 - i];
        }
      } else {
        ifZero = true;
      }
    }

    if (!result) {
      result = numberMap[0];
    }

    return result;
  };

  const firstLength = strNum.length % 4 ? strNum.length % 4 : 4;

  convertArray.push([].map.call(strNum.substr(0, firstLength), (c) => numberMap[c]).join(''));

  let i = strNum.length - firstLength;
  while (i > 0) {
    convertArray.push([].map.call(strNum.substr(strNum.length - i, 4), (c) => numberMap[c]).join(''));
    i -= 4;
  }

  return convertArray.reduce((sum, value, index) => {
    const num = compileNumber(value);

    if (num === numberMap[0]) {
      return sum;
    } else if (index > 0 && compileNumber(convertArray[index - 1]) === numberMap[0] && num !== numberMap[0]) {
      sum += numberMap[0] + num + units[convertArray.length - 1 - index];

      return sum;
    }

    return sum + num + units[convertArray.length - 1 - index];
  }, '');
};
/** 判断两个值是否相等
 * @param a{any},
 * @param b{any}
 * @returns {Boolean}
 */
const isEqual = (a, b, aStack, bStack) => {
  const toString = Object.prototype.toString;

  function deepEq(a, b, aStack, bStack, env) {
    // a 和 b 的内部属性 [[class]] 相同时 返回 true
    const className = toString.call(a);
    if (className !== toString.call(b)) {
      return false;
    }

    switch (className) {
      case '[object RegExp]':
      case '[object String]':
        return `${a}` === `${b}`;
      case '[object Number]':
        if (+a !== +a) {
          return +b !== +b;
        }
        return +a === 0 ? 1 / +a === 1 / b : +a === +b;
      case '[object Date]':
      case '[object Boolean]':
        return +a === +b;
      default:
    }

    const areArrays = className === '[object Array]';
    // 不是数组
    if (!areArrays) {
      // 过滤掉两个函数的情况
      if (typeof a !== 'object' || typeof b !== 'object') {
        return false;
      }

      const aCtor = a.constructor;
      const bCtor = b.constructor;
      // aCtor 和 bCtor 必须都存在并且都不是 Object 构造函数的情况下，aCtor 不等于 bCtor， 那这两个对象就真的不相等啦
      if (
        aCtor === bCtor &&
        !(env.isFunction(aCtor) && aCtor instanceof aCtor && env.isFunction(bCtor) && bCtor instanceof bCtor) &&
        'constructor' in a &&
        'constructor' in b
      ) {
        return false;
      }
    }

    aStack = aStack || [];
    bStack = bStack || [];
    let length = aStack.length;

    // 检查是否有循环引用的部分
    while (length--) {
      if (aStack[length] === a) {
        return bStack[length] === b;
      }
    }

    aStack.push(a);
    bStack.push(b);

    // 数组判断
    if (areArrays) {
      length = a.length;
      if (length !== b.length) {
        return false;
      }

      while (length--) {
        if (!env.isEqual(a[length], b[length], aStack, bStack)) {
          return false;
        }
      }
    }
    // 对象判断
    else {
      const keys = Object.keys(a);
      let key;
      length = keys.length;

      if (Object.keys(b).length !== length) {
        return false;
      }
      while (length--) {
        key = keys[length];
        if (!(b.hasOwnProperty(key) && env.isEqual(a[key], b[key], aStack, bStack))) {
          return false;
        }
      }
    }

    aStack.pop();
    bStack.pop();
    return true;
  }

  // === 结果为 true 的区别出 +0 和 -0
  if (a === b) {
    return a !== 0 || 1 / a === 1 / b;
  }

  // typeof null 的结果为 object ，这里做判断，是为了让有 null 的情况尽早退出函数
  // if (a == null || b == null) return false;

  // 判断 NaN
  // 不知道咋写，先注释掉了
  // if (a !== a) return b !== b;

  // 判断参数 a 类型，如果是基本类型，在这里可以直接返回 false
  const type = typeof a;
  if (type !== 'function' && type !== 'object' && typeof b !== 'object') {
    return false;
  }

  // 更复杂的对象使用 deepEq 函数进行深度比较
  return deepEq(a, b, aStack, bStack);
};

const checkTelValid = (tel) => {
  const ret = {
    code: -1,
    message: '',
  };
  if (!tel || tel == '') {
    ret.message = '电话不能为空';
    return ret;
  }
  if (tel.length < 6 || tel.length > 15) {
    ret.message = '电话号码长度不对';
    return ret;
  }
  if (!RegxConstant.tel.CN_MobilePhone.test(tel)) {
    ret.message = '无效的电话号码';
    return ret;
  }
  ret.code = 0;
  return ret;
};

const isChina = (s) => {
  if (!s) {
    return false;
  }
  return RegxConstant.chinese.test(s);
};

const ruleResultMessage = (result) => {
  if (!result) {
    return result;
  }

  if (isChina(result.description)) {
    const t = result.message;
    result.message = result.description;
    result.description = t;
  }

  return result;
};

/**
 * 校验Array是否是最后一页
 * @param data
 */
const isListLastPage = (jsonData) => {
  if (jsonData) {
    // 旧版的pipe接口（新版数据结构没有类似字段）
    if (Array.isArray(jsonData.data)) {
      if (jsonData.data.length > 0) {
        if (typeof jsonData.current_page === 'number' && typeof jsonData.total_pages === 'number') {
          return jsonData.current_page === jsonData.total_pages;
        }
      }
    } else if (jsonData.totalCount && jsonData.pageSize && jsonData.pageSize > 0) {
      return jsonData.pageIndex >= jsonData.totalCount / jsonData.pageSize;
    }
  }
  return true;
};

/**
 * 合并参数到url
 * @param {*} host
 * @param {*} paramObj
 */
const combineUrl = (host, paramObj) => {
  let url = host || '';

  if (paramObj) {
    let first = true;
    if (url.indexOf('?') > 0) {
      first = false;
    }

    for (const k in paramObj) {
      if (first) {
        url += '?';
        first = false;
      } else {
        url += '&';
      }

      url += `${k}=${FormEncode(param[k])}`;
    }
  }

  return url;
};

const bookingPayTimeInfo = (final_start_time) => {
  const date = new Date(final_start_time * 1000);
  if (date.getMinutes() == 0) {
    return date.getMonth() + 1 + '月' + date.getDate() + '日 ' + date.getHours() + '点开始支付尾款';
  } else {
    return (
      date.getMonth() +
      1 +
      '月' +
      date.getDate() +
      '日 ' +
      date.getHours() +
      '点' +
      date.getMinutes() +
      '分开始支付尾款'
    );
  }
};

const addParam = (url, key, value) => {
  const hashReg = /#.+$/;
  let hash = url.match(hashReg) || [];
  hash = hash[0] || '';
  url = url
    .replace(hashReg, '')
    .replace(new RegExp(`[?&]${key}=[^&]*&?`, 'g'), (str) => (str[str.length - 1] === '&' ? str[0] : ''));
  let linkSymbol = '&';
  if (url.indexOf('?') === -1) {
    linkSymbol = '?';
  }
  return `${url}${linkSymbol}${key}=${value}${hash}`;
};

const addParams = (url = '', kv = []) => {
  if (!url) {
    return url;
  }
  kv.forEach((item) => {
    const k = item.key;
    const v = item.value;
    url = addParam(url, k, v);
  });
  return url;
};

const reserveArray = (array) => {
  if (!Array.isArray(array)) {
    return [];
  }

  const result = [];

  for (let i = array.length - 1; i >= 0; --i) {
    result.push(array[i]);
  }

  return result;
};
// 对象深层数据取值
// static get = (path, initValue) => path.reduce((accumulator, currentValue) => (accumulator && accumulator[currentValue]) ? accumulator[currentValue] : null, initValue)
const get = (path, initValue) => {
  return path.reduce(
    (accumulator, currentValue) => (accumulator && accumulator[currentValue] ? accumulator[currentValue] : null),
    initValue,
  );
};

/**
 * 小数加、减、乘、除 保留精度计算
 * @param {Number} value
 * @param {Number} decimals
 * for example
 *      precisionRound(0.1 + 0.2, 2) 返回结果0.3
 */
const precisionRound = (value, decimals) => {
  return Number(`${Math.round(`${value}e${decimals}`)}e-${decimals}`);
};

/**
 * 数组处理：将一维数组变为N维数组
 * @param {*} arr
 * @param {*} len
 */
const splitArray = (arr, len) => {
  const arr_length = arr.length;
  const newArr = [];
  for (let i = 0; i < arr_length; i += len) {
    newArr.push(arr.slice(i, i + len));
  }
  return newArr;
};

/**
 * 深拷贝
 * @param obj
 * @param hash
 * @returns {any}
 */
const deepCopy = (obj, hash = new WeakMap()) => {
  if (typeof obj !== 'object' || obj === null) {
    return obj;
  }
  let cloneObj;
  const Constructor = obj.constructor;
  switch (Constructor) {
    case RegExp:
      cloneObj = new Constructor(obj);
      break;
    case Date:
      cloneObj = new Constructor(obj.getTime());
      break;
    default:
      if (hash.has(obj)) {
        return hash.get(obj);
      }
      cloneObj = new Constructor();
      hash.set(obj, cloneObj);
  }
  for (const key in obj) {
    cloneObj[key] = typeof obj[key] === 'object' ? deepCopy(obj[key], hash) : obj[key];
  }
  return cloneObj;
};

/**
 * 分解小数
 */
const divideNum = (num = 0) => {
  const numStr = String(num);
  const arr = numStr.split('.');
  if (arr.length == 1) {
    arr.push('00');
  }
  return arr;
};

const trimObj = (obj) => {
  const o = obj;
  for (const i in obj) {
    const value = obj[i];
    if (typeof value === 'string') {
      o[i] = value.trim();
    }
  }
  return o;
};
/**
 * 对iid进行encode
 * 存在需要encode的符号  ----> encode(value)
 * iid=object时，判断value是否是url且需要encode，再对整体进行encode
 * @param {*} iid 打点iid
 */
const encodeIid = (iid) => {
  const httpReg = /^(http|https)/;
  try {
    if (typeof iid === 'string') {
      if (!RegxConstant.encodeReg.test(iid)) {
        return iid;
      } else {
        iid = encodeURIComponent(iid);
      }
    } else if (typeof iid === 'object') {
      iid = encodeURIComponent(
        Object.keys(iid)
          .map((item) => {
            const value =
              httpReg.test(iid[item]) && RegxConstant.encodeReg.test(iid[item])
                ? encodeURIComponent(iid[item])
                : iid[item];
            return `${item}=${value}`;
          })
          .join('&'),
      );
    }
    return iid;
  } catch (e) {
    return iid;
  }
};

const isNullOrUndefined = (val) => {
  return val === null || typeof val === 'undefined';
};

// fn为同步或者异步均可, 没有根据args做缓存
const getConfWithCache = (fn, time) => {
  let res = null;
  let preTime = 0;
  return async (...args) => {
    const now = Date.now();
    if (res && now - preTime < time * 1000) {
      return res;
    }
    res = (async () => fn(...args))();
    preTime = now;
    res.catch((e) => {
      res = null;
    });
    return res;
  };
};

const formatNumToStr = (obj) => {
  const newObj = {};
  for (const k of Object.keys(obj)) {
    if (typeof obj[k] === 'number') {
      newObj[k] = obj[k] + '';
    } else if (typeof obj[k] === 'object') {
      newObj[k] = formatNumToStr(obj[k]);
    } else {
      newObj[k] = obj[k];
    }
  }
  return newObj;
};
const _keyStr = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=';
const encodeBase64 = function (input) {
  let output = '';
  let chr1, chr2, chr3, enc1, enc2, enc3, enc4;
  let i = 0;

  while (i < input.length) {
    chr1 = input.charCodeAt(i++);
    chr2 = input.charCodeAt(i++);
    chr3 = input.charCodeAt(i++);

    enc1 = chr1 >> 2;
    enc2 = ((chr1 & 3) << 4) | (chr2 >> 4);
    enc3 = ((chr2 & 15) << 2) | (chr3 >> 6);
    enc4 = chr3 & 63;

    if (isNaN(chr2)) {
      enc3 = enc4 = 64;
    } else if (isNaN(chr3)) {
      enc4 = 64;
    }

    output = output + _keyStr.charAt(enc1) + _keyStr.charAt(enc2) + _keyStr.charAt(enc3) + _keyStr.charAt(enc4);
  }
  return output;
};
/**
 *
 * @param {*} fn 实际要执行的函数
 * @param {*} times 最多执行的次数
 * @param {*} duration 发生错误时需等待的时间
 * @returns
 */
const retry = (fn, times = 3, duration = 0) => {
  let currentTime = 0;
  return async (...args) => {
    const exec = async () => {
      try {
        return await fn(...args);
      } catch (e) {
        currentTime++;
        if (currentTime <= times) {
          return new Promise((resolve) => {
            setTimeout(() => {
              resolve(exec());
            }, duration);
          });
        } else {
          throw e;
        }
      }
    };
    return await exec();
  };
};
const dealLatLong = (params) => {
  if (params.latitude && params.longitude) {
    return {
      ...params,
      ciphertextFlag: true,
      latitude: encodeBase64(`${params.latitude}`),
      longitude: encodeBase64(`${params.longitude}`),
    };
  } else {
    return params;
  }
};
const funcs = {
  isThisIsMiGood,
  computeIsLockRecLoad,
  parseExtImages,
  parseImageSize,
  getObjProps,
  getArrValue,
  getObjPropsV2,
  parseExtColor,
  isArray,
  isFunction,
  isObject,
  isEmptyObj,
  unique,
  amountFormat,
  getFormatPrice,
  currentTimeStamp,
  parseQueryString,
  urlParse,
  updateQueryString,
  getImgSize,
  webpFormat,
  webpFormatZip,
  convertToChineseNumber,
  isEqual,
  checkTelValid,
  isChina,
  ruleResultMessage,
  isListLastPage,
  combineUrl,
  bookingPayTimeInfo,
  addParam,
  addParams,
  reserveArray,
  get,
  precisionRound,
  splitArray,
  deepCopy,
  divideNum,
  trimObj,
  encodeIid,
  isNullOrUndefined,
  getConfWithCache,
  formatNumToStr,
  encodeBase64,
  retry,
  dealLatLong,
};
export { getObjPropsV2, currentTimeStamp, unique };

export default funcs;
